import {httpMonitorAPI} from 'features/http/api/httpMonitorAPI';
import {IHttpMonitorItem} from 'features/http/model/HttpMonitor/IHttpMonitor';

export const useHttpMonitorAvgResponseTime = (uuid?: string, item?: IHttpMonitorItem) => {
    const {data, isLoading, error} = httpMonitorAPI.useGetHttpMonitorAvgResponseTimeQuery(uuid ?? '', {skip: !uuid});

    return {
        data,
        isLoading,
        hasError: Boolean(error),
        paused: item?.status === 'paused',
    };
};

export default useHttpMonitorAvgResponseTime;
